<template>
    <div id="skuPage">
        <div style="position: fixed;background: rgba(0, 0, 0, .075);width: 100%;height: 100%;z-index: 999" v-if="isBtnajax">
            <a-spin style="transform:translate(-50%,-50%);position: absolute;top: 50%; left: 50%;"/>
        </div>

        <div v-if="skuLoading">
            <a-spin :spinning="skuLoading">
            <a-skeleton active />
            </a-spin>
        </div>
        <div v-else class="skupage" >
            <table-coms
                v-if="data.tableList != undefined"
                :tableData="SkuTableData"
                :cols="SkuTableColumns"
                :key="substr"
                :fixedNum="fixedNum"
                v-on:rederSub="GetrederSub"
                :checkboxFlag="true"
                v-on:selectRowData="getSelectDataTop"
                v-on:checkBoxSelectData="getBoxSelectData"
                :loading="parloading"
                ref="tablsRef"
                :setGmcuid="tableGmcuid"
                :subParAnsear="true"
                v-on:renderSearchVal="getredSearchVal"
                v-on:renderSortVal="getrenderSortVal"
                v-on:renderQueryVal="getrenderQueryVal"
                :MaxHeight="MaxHeight"
            >
                <template slot="topFunction">
                <div style="display: flex;justify-content: space-between;width: calc(100% - 10px);height: 35px;align-items: center;">
                    <!--按钮-->
                    <div>
                        <span style="float: left;">
                            <function-bar
                                    @handleToolClick="handleToolClick"
                                    :buttonsObj="data.functionBtn"></function-bar>
                        </span>
                        <span style="float: left;margin-left: 4px;">
                            <a-icon type="search" style="margin-right: 4px;"/>
                            <a-select style="width: 180px" size="small" @change="skuTableTemplateData" v-model="parTableTemplateName" placeholder="Please select template">   
                                <a-select-option value="all">all</a-select-option>
                                <a-select-option
                                        :key="item"
                                        :value="item"
                                        v-for="item in parTableTemplateSelect">{{ item }}</a-select-option>
                            </a-select>
                        </span>
                    </div>
                    <!--分页-->
                    <div>
                        <a-pagination
                            :pageSizeOptions="pageSizeOptions"
                            :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
                            size="small"
                            :total="pagingTotal"
                            v-model="currentVal"
                            :pageSize.sync="pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            showSizeChanger
                        />
                    </div>
                </div>
                </template>
            </table-coms>
        </div>
        <tabs-table
            v-if="data.tabs != undefined"
            :tabsData="data.tabs"
            :targetUID="targetUID"
            :showTitleValue="showTitleValue"
            :parTabelEditVerSion = "parTabelEditVerSion"
            :tabsActive="tabsActive"
            :allCheckbox="pb_selectList"
            :notShowEditPageSaveBtn="notShowEditPageSaveBtn"
            ref="tabsTable">
        </tabs-table>
        <edit-from
            :QueryUpdatas="QueryUpdatas"
            :visible="eddvisible"
            v-on:cancelModalVisible="GETcancelModalVisible"
            :apiType="apiType">
        </edit-from>
        <import-modal
            :visible="importVisible"
            v-on:cancelImport="GETcancelImport"
            :importparams="importparams">
        </import-modal>
        <manual ref="manual" :manualParams="manualParams"></manual>
        <popup-single
            ref="popupSingleRef"
            :QueryUpdatas="QueryUpdatas">
        </popup-single>
        <generate-location
            ref="generateLocationRef"
            v-on:generatelocation="getGeneratelocation">
        </generate-location>
        <create-wave ref="createWaveRef"></create-wave>
        <bath-update
            ref="bathUpdateRef"
            v-on:cancelModalVisible="GETcancelModalVisible">
        </bath-update>
        <scanpack ref="scanpackRefs"></scanpack>
        <scan-in ref="scanInRefs"></scan-in>
        <loading ref="loadingRefs"></loading>
        <adjust ref="adjust"></adjust>
        <move ref="adjustMove" v-on:moveSave="getMoveSave"></move>
        <split ref="splitRef"></split>
        <delivery-date ref="deliveryDate" v-on:deliverdate="getdeliverdate"></delivery-date>
        <trans-fer ref="transfer"></trans-fer>
        <look-up ref="lookupRefs" :lookupdata="lookupParams"></look-up>
        <batch-update-shipment ref="batchShipment"></batch-update-shipment>
        <button-config ref="buttonConfigRef" v-on:btnConfigemit="getBtnConfigemit"></button-config>
        <lpn-print ref="lpnPrintRef"></lpn-print>
        <shdule-batch ref="shduleBatchRef"></shdule-batch>
        <add-consignment ref="addConsignmentRefs" v-on:cancelImport="GETcancelImport"></add-consignment>
        <add-pallet :visible="addPalletVisible" v-on:cancelImport="GETcancelImport" :importparams="importparams"></add-pallet>
    </div>
</template>
<script>
import addConsignment from './custPage/addConsignment.vue'
import functionBar from "./components/functionBar.vue";
import tabsTable from "./components/tabsTable.vue";
import editFrom from "./components/editFrom.vue";
import importModal from "./components/importModal.vue";
import manual from "./manual.vue";
import popupSingle from "./components/popupSingle.vue";
import generateLocation from "./custPage/generateLocation.vue";
import createWave from "./custPage/createWave.vue";
import bathUpdate from "./custPage/bathUpdate.vue";
import scanpack from "./custPage/scanpack.vue";
import scanIn from './custPage/scanIn.vue'
import loading from './custPage/loading.vue'
import adjust from './custPage/adjust.vue'
import move from './custPage/move.vue'
import split from './custPage/split.vue'
import transFer from './custPage/transfer.vue'
import deliveryDate from './custPage/deliverydate.vue'
import lookUp from "./custPage/lookup.vue";
import batchUpdateShipment from "./custPage/batchUpdateShipment.vue"
import buttonConfig from "./custPage/buttonConfig.vue"
import lpnPrint from "./custPage/lpnPrint.vue"
import addPallet from "./custPage/addPallet.vue"
import shduleBatch from "./sheduleComs/batch.vue"

import tableComs from "../com/tableComs.vue";
import andOr from "../com/queryBuilder/components/AndOR.vue";
import ajax from "../../api/ajax";
import api from "../../api/url";
import { mapState } from "vuex";
import axios from "axios";
import cookie from "../../api/cookie";
import moment from "moment";
export default {
    components: {
        addConsignment,
        loading,
        andOr,
        tableComs,
        importModal,
        functionBar,
        tabsTable,
        editFrom,
        manual,
        popupSingle,
        generateLocation,
        createWave,
        bathUpdate,
        scanpack,
        scanIn,
        adjust,
        move,
        split,
        transFer,
        deliveryDate,
        lookUp,
        batchUpdateShipment,
        buttonConfig,
        lpnPrint,
        addPallet,
        shduleBatch
    },
    computed: {
        ...mapState(["FUNAPI"]),
        ...mapState(["lang"]),
    },
    data() {
        return {
            notShowEditPageSaveBtn: false,
            SkuTableColumns: [],
            tabsActive: '0',
            showTitleValue: [],
            lookupParams: {},
            pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
            parTableTemplateSelect:[],
            parTabelEditVerSion: null,
            skuLoading: true,
            options: {
                condition: [],
                fieldNameSel: []
            },
            isFirst: true,
            fixedNum: 0, // 需要固定
            substr: 0, // 更新组件下标
            targetUID: null, // 点击表格转给弹窗uid
            tableGmcuid: "", // 后台返回GMUID
            pagingTotal: 0, // 总数
            pagingSize:  Number.parseInt(sessionStorage.getItem('pageSize') || '30'), // 条数
            currentVal: 1, // 页数
            pageInfoType: "", // 分页查询条件
            customStyle: "border: 0;overflow: hidden",
            pb_selectList: [], // 表格check选中
            shipmentUrl: [], // cfsShipment show url
            parloading: true, // 夫加载
            eddvisible: false,
            QueryUpdatas: {},
            apiType: "",
            funApi: "",
            strsub: 1,
            importVisible: false,
            addPalletVisible: false,
            TitleSearchVal: [], // 表格title search 条件
            importparams: {}, // 传个iport 参数
            manualParams: {}, // 转个manual 参数
            bathUpdatparams: {},
            initRenderFnSearchParamsArr: {
                SortValArr: [],
                titleSearchArr: [],
                andvanSearchArr: {}
            },
            MaxHeight: 0,
            parTableTemplateName: undefined,
            SkuTableData: [],
            isBtnajax: false,
            data: {}
        };
    },
    //  inject: ["reload"],
    created() {
        this.MaxHeight = document.body.clientHeight - 160;
        this.data = {} // 表格数据
        this.init("empty_temp")
    },
    activated() {
        let refreshCycleCount = sessionStorage.getItem("refreshCycleCount");
        if(refreshCycleCount == 'Y') {
            sessionStorage.removeItem("refreshCycleCount");
            this.init("all");
        }
    },
    methods: {
        cleardata(){
            this.data = []
            this.init()
        },
        skuTableTemplateData(val){
            this.clearImportUids();
            this.parTableTemplateName  = val
            this.parloading = true;
            let jsonArray = {};
            jsonArray.gmcUid = this.tableGmcuid;
            this.pageInfoType = "qf";
            this.currentVal = 1;
            this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
            this.initRenderFn();
        },
        getTemplateName(){
            ajax.get(api.ADVANCETEMPLATE, { gmcUid: this.tableGmcuid }).then(res => {
                this.parTableTemplateSelect = res.data
                // if(this.parTableTemplateSelect.length> 0){
                //  this.parTableTemplateName = this.parTableTemplateSelect[0]
                // }
            });
        },
        //      generatelocation 返回的值刷新init
        getGeneratelocation() {
            this.init();
        },
        //      sort
        getrenderSortVal(paramsArr) {
            this.parloading = true;
            this.pageInfoType = "sort";
            this.currentVal = 1;
            this.initRenderFnSearchParamsArr.SortValArr = paramsArr;
            this.initRenderFn();
        },
        //      titleSearch
        getredSearchVal(val) {
            this.TitleSearchVal = val;
            let scParams = [];
            let tt = JSON.parse(JSON.stringify(val))
            tt.forEach((v, i) => {
                if(v.type == "Datetime"){
                    if(v.serVal){
                        v.serVal = moment(v.serVal).format('YYYY-MM-DD HH:mm:ss')
                    }
                }
                if (v.type == "Date") {
                    if(v.serVal){
                        v.serVal =  moment(v.serVal).format('YYYY-MM-DD')
                    }
                }
                if (v.serVal) {
                    if( Array.isArray(v.serVal)){
                        for(let i in v.serVal){
                            scParams.push({ key: v.uid, value: v.serVal[i] });
                        }
                    }else{
                        scParams.push({ key: v.uid, value: v.serVal });

                    }
                }
            });
            this.pageInfoType = "tle";
            this.currentVal = 1;
            this.initRenderFnSearchParamsArr.titleSearchArr = scParams;
            this.initRenderFnSearchParamsArr.andvanSearchArr = [];
            this.initRenderFn();
        },

        //      query filter提交
        getrenderQueryVal(item) {
            this.clearImportUids()
            this.parloading = true;
            let jsonArray = item.query;
            jsonArray.gmcUid = this.tableGmcuid;
            let templateName  = item.tml
            if(templateName != undefined && templateName != null){
                this.parTableTemplateName  = templateName 
            }      
            this.pageInfoType = "qf";
            this.currentVal = 1;
            this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
            this.initRenderFnSearchParamsArr.titleSearchArr = [];
            this.initRenderFn();
        },
        //      选择条数
        onShowSizeChange(current, pageSize) {
            this.currentVal = current;
            this.pagingSize = pageSize;
            this.initRenderFn();
        },
        //      表格分页
        tableChangePage(current) {
            this.currentVal = current;
            this.initRenderFn();
        },
        //      何在一起三个
        initRenderFn() {
            this.$nextTick(()=>{
                //  console.info('DDD 33')
                this.parloading = true;
                let params = {
                    functionUid: this.$route.query.funcUid,
                    gmcUid: this.tableGmcuid,
                    language: this.lang,
                    userUid: this.$route.query.userUid,
                    paging: {
                        pageNum: this.currentVal,
                        pageSize: this.pagingSize
                    }
                };
                //                sesstion 有importUid 加上这个参数
                let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                let topMenuActive = sessionStorage.getItem("menuActive")
                for(let i in topMenu){
                    if(topMenu[i].key == topMenuActive){
                        if(topMenu[i].importUids){
                            params.importUids = topMenu[i].importUids
                        }
                    }
                }

                if (this.pageInfoType == "sort") {
                    params.userSortDtos = this.initRenderFnSearchParamsArr.SortValArr;
                } else if (this.pageInfoType == "tle") {
                    params.columnSearch = this.initRenderFnSearchParamsArr.titleSearchArr;
                } else if (this.pageInfoType == "qf") {
                    params.userSqlDto = this.initRenderFnSearchParamsArr.andvanSearchArr;
                    params.userSqlDto.template = this.parTableTemplateName;
                }
                ajax.post(api.SKUS, params).then(res => {
                    if (res.code == 200) {
                        this.parloading = false
                        this.data.tableList.data = res.data.tableList.data;
                        this.data.tableList.columns = res.data.tableList.columns;
                        this.SkuTableData = res.data.tableList.data;
                        let tt = this.data.tableList.data
                        this.SkuTableData = tt
                        let newColums = this.data.tableList.columns;
                        if(this.SkuTableColumns.length > 0){
                            for(let i of newColums ){
                                for(let t of this.SkuTableColumns ){
                                    if(i.uid == t.uid ){
                                        t.statisticsValue4OnePage = i.statisticsValue4OnePage
                                    }
                                }
                            }
                        }

                        this.$refs.tablsRef.newData()
                        this.getTemplateName()
                        //    是否分页
                        if(res.data.tableList.paging != null){
                            this.pagingTotal = res.data.tableList.paging.totalPageSize;
                        }
                        //    存在编辑按钮隐藏
                        let arrFn = this.data.functionBtn;
                        for (let i in arrFn) {
                            let tt = arrFn[i].children;
                            for (let j in tt) {
                                if (tt[j].code == "BTN_EDIT" || ( tt[j].pattern != null && (tt[j].pattern.custPage == "shedule_addPro" || tt[j].pattern.custPage == "shedule_batch"))) {
                                    tt[j].editFlag = "1";
                                }
                            }
                        }
                        let tabs = this.data.tabs
                        for(let i in tabs){
                            if(tabs[i].loadable == '1'){
                                this.tabsActive = i
                            }
                        }
                    } else {
                        this.$customMessage.warning(res.msg, 3);
                    }
                });
            })
        },
        //      获取初始化数据
        init(type) {
            this.initRenderFnSearchParamsArr.SortValArr= []
            this.initRenderFnSearchParamsArr.titleSearchArr = []
            this.initRenderFnSearchParamsArr.andvanSearchArr = {}
            // this.parTableTemplateName = undefined
            if (type == "editok") {
                this.initRenderFn();
            }
            this.skuLoading = true;
            this.funApi = this.$route.query.funApi;
            if (this.funApi==""){
                return;
            }
            this.currentVal = 1;
            let params = {
                userUid: this.$route.query.userUid,
                functionUid: this.$route.query.funcUid,
                language: this.lang,
                pageNum: this.currentVal,
                pageSize: this.pagingSize
            };
            if( "empty_temp" != type ){
                let templateName = this.parTableTemplateName;
                if(templateName == null || templateName == undefined){
                    this.parTableTemplateName = type
                    templateName = type;
                }
                this.pageInfoType = "qf"
                params.userSqlDto = {};
                params.userSqlDto.template = templateName
            }else{
                this.parTableTemplateName = undefined
            }
            this.pb_selectList = [];
            if(params.userUid == undefined && params.functionUid == undefined){
                //this.$customMessage.warning(this.$t('publicLang.IncorrectConfiguration'), 3)
            }
            // sesstion 有importUid 加上这个参数
            let topMenu = JSON.parse(sessionStorage.getItem("menu"))
            let topMenuActive = sessionStorage.getItem("menuActive")
            for(let i in topMenu){
                if(topMenu[i].key == topMenuActive){
                    if(topMenu[i].importUids){
                        params.importUids = topMenu[i].importUids
                    }
                }
            }
                // console.log("skuPage: "+this.funApi)
            ajax.get(this.funApi, params).then(res => {
                this.skuLoading = false;
                if (res.code == 200) {
                    if(res.data.tableList.paging != null){
                        this.pagingTotal = res.data.tableList.paging.totalPageSize;
                    }
                    this.parloading = false;
                    this.substr = this.substr + 1;
                    this.data = res.data;
                    this.tableGmcuid = res.data.gmcUid;
                    let tt = this.data.tableList.data

                    let columns = this.data.tableList.columns
                    this.SkuTableColumns = columns
                    for(let i in columns){
                        if(columns[i].type == 'DROP'){
                            columns[i].serVal = []
                        }
                    }
                    this.SkuTableData = tt
                    this.getTemplateName()
                    let arrFn = this.data.functionBtn;
                    for (let i in arrFn) {
                        let tt = arrFn[i].children;
                        for (let j in tt) {
                            if (tt[j].code == "BTN_EDIT" ||(tt[j].pattern != null && (tt[j].pattern.custPage == "shedule_addPro" || tt[j].pattern.custPage == "shedule_batch"))) {
                                tt[j].editFlag = "1";
                            }
                        }
                    }
                }
            });
        },
        //      清楚缓存中的ImportUids
        clearImportUids(){
            let topMenu = JSON.parse(sessionStorage.getItem("menu"))
            let topMenuActive = sessionStorage.getItem("menuActive")
            for(let i in topMenu){
                if(topMenu[i].key == topMenuActive){
                    if(topMenu[i].importUids){
                        delete topMenu[i].importUids
                    }
                }
            }
            sessionStorage.setItem("menu", JSON.stringify(topMenu));
        },
        //      操作固定width 需要重新渲染组件
        GetrederSub(val) {
            this.fixedNum = val;
            this.substr = this.substr + 1;
        },
        //      点击表格组件返回的当条数据，传给弹窗
        getSelectDataTop(val) {
            this.showTitleValue = []
            let arrFn = this.data.functionBtn;
            let tt = 0
            for (let i in arrFn){
                for(let t in arrFn[i].children){
                    if(arrFn[i].children[t].code == 'BTN_EDIT'){
                        if(arrFn[i].children[t].pattern.custPage == "Putaway" && arrFn[i].children[t].type == "BUTTON"){
                            let paramsData = [];
                            let paramsObj = {}
                            paramsObj.key = "uid";
                            paramsObj.value = val.uid;
                            paramsData.push(paramsObj)
                            let edit = {
                                behrUid: val.btnUid,
                                userUid: this.$route.query.userUid,
                                functionUid: this.$route.query.funcUid,
                                params: paramsData,
                                language: this.lang
                            }
                            this.$refs.adjustMove.show('Putaway',val.edit)
                            return
                        }
                        if(arrFn[i].children[t].pattern.custPage == "move" && arrFn[i].children[t].type == "BUTTON"){
                            this.$refs.adjustMove.show('moveGener',val.uid)
                            return
                        }else if(arrFn[i].children[t].pattern.custPage == "transfer" && arrFn[i].children[t].type == "BUTTON"){
                            this.$refs.transfer.show2(val.uid,false,true)
                            return
                        }else if(arrFn[i].children[t].pattern.custPage == "Adjust" && arrFn[i].children[t].type == "BUTTON"){
                            this.$refs.adjust.show2(val.uid,true)
                            return
                        }
                        tt = tt + 1
                    }
                }
            }

            if(tt == 0){
                this.notShowEditPageSaveBtn = true;
            }

            let tabs = this.data.tabs
            if( this.data.editBtnInfo == null ||  this.data.editBtnInfo.gmcUid == null ){
                return
            }
            this.tabsActive = '0'
            for(let i in tabs){
                if(tabs[i].loadable == '1'){
                    this.tabsActive = i
                }
            }
            this.$store.commit("updataPartStatus", { partStatus: val.status });
            if(val.uid == this.targetUID){
                this.$refs.tabsTable.showDawer()
                return
            }
            //   this.$refs.tabsTable.showDawer(val.version);
            this.targetUID = val.uid;
            if(val.showTitleValue.length > 0){
                this.showTitleValue = val.showTitleValue
            }else{
                this.showTitleValue = []
            }
            this.parTabelEditVerSion = val.version
        },
        //      获取表格checkbox
        getBoxSelectData(val) {
            this.pb_selectList = val;
        },
        //      pdf 成功下载方法
        pubPdfUploadOk(data){
            this.isBtnajax = false
            this.$store.commit("updataLoading", { pbLoading: false });
            let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
            let url = window.URL.createObjectURL(blob);
            window.open(url);
        },
        // paf接口返回值处理
        pubPdfMsgfn(res){
            let data = res.data;
            let fileReader = new FileReader();
            let that = this
            fileReader.onload = function() {
                try {
                    let jsonData = JSON.parse(this.result);
                    if (jsonData.code) {
                        that.$customMessage.warning(jsonData.msg);
                        that.$store.commit("updataLoading", { pbLoading: false });
                        that.isBtnajax = false
                    }
                } catch (err) {
                    that.pubPdfUploadOk(res)
                }
            };
            fileReader.readAsText(data)
        },
        //      功能
        handleToolClick(val) {
            if (val.code === "BTN_UPDATE") {
                if (this.pb_selectList.length < 1) {
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                    return;
                }
                let that = this;
                this.$customConfirm({
                    title: that.$t('publicLang.AreUpadte'),
                    content: "",
                    onOk() {
                        that.isBtnajax = true
                        let deleteData = that.pb_selectList;
                        let paramsData = [];
                        for (let index in deleteData) {
                            if (deleteData[index].uid != "") {
                                let paramsObj = {};
                                paramsObj.key = "uid";
                                paramsObj.value = deleteData[index].uid;
                                paramsData.push(paramsObj);
                                paramsData.push({
                                    key: "version",
                                    value: deleteData[index].version
                                });
                            }
                        }
                        let params = {
                            behrUid: val.btnUid,
                            userUid: that.$route.query.userUid,
                            functionUid: that.$route.query.funcUid,
                            gmcUid: val.pattern.gmcUid,
                            params: paramsData,
                            type: "update",
                            language: that.lang
                        };

                        ajax.post(api.UPDATE, params).then(res => {
                            that.isBtnajax = false
                            if (res.code === 200) {
                                that.$message.success(res.msg);
                                that.initRenderFn();
                                that.pb_selectList = [];
                            } else {
                                that.$customConfirm({
                                    title: res.msg,
                                    okText: "Yes",
                                    okType: "confirm",
                                    cancelText: "No",
                                    onOk() {
                                        that.initRenderFn();
                                    }
                                });
                            }
                        });
                    }
                });
            }
            if (val.code == "BTN_REFRESH") {
                this.clearImportUids()
                this.init("all");
            }
            //        添加
            if (val.code === "BTN_ADD") {
                if(val.pattern.custPage == "Putaway" && val.type == "BUTTON"){
                    this.$refs.adjustMove.show('Putaway')
                    return
                }
                if(val.pattern.custPage == "lpnprint" && val.type == "BUTTON"){
                    this.$refs.lpnPrintRef.show()
                    return
                }

                let params = {
                    gmcUid: val.pattern.gmcUid,
                    language: this.lang
                };
                ajax.post(api.POPUP, params).then(res => {
                    this.apiType = "add";
                    this.QueryUpdatas = res;
                    this.QueryUpdatas.behrUid = val.btnUid;
                    this.QueryUpdatas.lookupCode = val.code;
                    this.QueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                    this.eddvisible = true;
                });
            }
            //        编辑
            if (val.code === "BTN_EDIT") {
                this.isBtnajax = true
                if (this.pb_selectList.length != 1) {
                    this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                    this.isBtnajax = false
                    return;
                } else {
                    this.QueryUpdatas = {};
                    let paramsData = [];
                    let dataValues = this.pb_selectList[0];
                    let params = {
                        gmcUid: val.pattern.gmcUid,
                        dataUid: dataValues.uid,
                        language: this.lang
                    };
                    this.eddvisible = true;
                    ajax.post(api.POPUP, params).then(res => {
                    this.QueryUpdatas = res;
                        this.isBtnajax = false
                        this.QueryUpdatas.behrUid = val.btnUid;
                        this.QueryUpdatas.lookupCode = val.code;
                        this.QueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                        this.apiType = "edit";
                    });
                }
            }
            //        删除
            if (val.code === "BTN_DELETE") {
                if (this.pb_selectList.length < 1) {
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                    return;
                }
                if(val.pattern.custPage == "Cron" || val.pattern.custPage == "Cron_task"){
                    let that = this
                    this.$customConfirm({
                        title: this.$t('pubGicSet.AreyoudeleTask'),
                        okText: this.$t('publicLang.Confirm'),
                        cancelText: this.$t('publicLang.Cancel'),
                        content: "",
                        onOk(){
                            that.isBtnajax = true
                            let deleteData = that.pb_selectList;
                            let paramsData = [];
                            for (let index in deleteData) {
                                paramsData.push(deleteData[index].uid)
                            }
                            let funcType  = ''
                            if(val.pattern.custPage == "Cron"){
                                funcType = 'WAVE'
                            }else{
                                funcType = 'SCHD_TASK'
                            }
                            ajax.post(api.DELETEJOBSCHEDULE,{uids: paramsData,funcType: funcType }).then(res=>{
                                that.isBtnajax = false
                                that.initRenderFn();
                                if (res.code === 200) {
                                    that.$message.success(that.$t("publicLang.DeleteSuccess"));
                                }else{
                                    that.$customMessage.error(res.msg);
                                }
                            })
                        }
                    })
                    return
                }
                let tt = [];
                for (let ii in this.pb_selectList) {
                    if (!this.pb_selectList[ii].deletable) {
                        tt.push(this.pb_selectList[ii].key + 1);
                    }
                }
                if (tt.length > 0) {
                    let cc;
                    cc = tt.join(",");
                    this.$customMessage.warning("[Row#"+cc+']'+this.$t('publicLang.NotAllowtodeleteCancel'),5);
                    return;
                }
                let that = this;
                this.$customConfirm({
                    title: this.$t('pubGicSet.AreyoudeleTask'),
                    okText: this.$t('publicLang.Confirm'),
                    cancelText: this.$t('publicLang.Cancel'),
                    content: "",
                    onOk() {
                        that.isBtnajax = true
                        let deleteData = that.pb_selectList;
                        let paramsData = [];
                        for (let index in deleteData) {
                            if (deleteData[index].uid != "") {
                                let paramsObj = {};
                                paramsObj.key = "uid";
                                paramsObj.value = deleteData[index].uid;
                                paramsData.push(paramsObj);
                                paramsData.push({
                                    key: "version",
                                    value: deleteData[index].version
                                });
                            }
                        }
                        let params = {
                            behrUid: val.btnUid,
                            userUid: that.$route.query.userUid,
                            functionUid: that.$route.query.funcUid,
                            gmcUid: val.pattern.gmcUid,
                            params: paramsData,
                            type: "delete",
                            language: that.lang
                        };
                        let apiUrl = api.UPDATE
                        if(val.patternType == "EXT"){
                            apiUrl = val.externalApi
                        }
                        ajax.post(apiUrl, params).then(res => {
                        that.isBtnajax = false
                        if (res.code === 200) {
                          that.pb_selectList = [];
                          that.initRenderFn();
                          that.$message.success(that.$t("publicLang.DeleteSuccess"));
                        } else {
                          that.$customMessage.error(res.msg);
                        }
                    });
                    }
                });
            }
            //        copy
            if (val.code == "BTN_COPY") {
                if (this.pb_selectList.length != 1) {
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                    return;
                } else {
                    this.QueryUpdatas = {};
                    let paramsData = [];
                    let dataValues = this.pb_selectList[0];
                    let params = {
                        gmcUid: val.pattern.gmcUid,
                        dataUid: dataValues.uid,
                        language: this.lang
                    };
                    this.eddvisible = true;
                    ajax.post(api.POPUP, params).then(res => {
                        this.QueryUpdatas = res;
                        this.QueryUpdatas.behrUid = val.btnUid;
                        this.QueryUpdatas.lookupCode = val.code;
                        this.QueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                        this.apiType = "edit";
                    });
                }
            }
            //        import
            if (val.code == "BTN_IMPORT") {
                let params = {
                btnUid: val.btnUid,
                userUid: this.$route.query.userUid,
                language: this.lang,
                fieldMapUid: val.mapUid,
                importTitle: val.name,
                isMove: val.pattern.custPage
            };

            if(val.type == "POPUP" && val.viewType == "SINGLE"){
                let specialModule = []
                if(this.data.tableList.info == "GR_HEADER"){
                    if(this.pb_selectList.length < 1){
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return
                    }
                    specialModule = this.pb_selectList
                }else{
                    if (this.pb_selectList.length != 1){
                        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                        return;
                    }
                }

                this.QueryUpdatas = {};
                let paramsData = [];
                let dataValues = this.pb_selectList[0];
                params = {
                    gmcUid: val.pattern.gmcUid,
                    importForView: {
                        dataUid: dataValues.uid,
                        gmcUid: this.tableGmcuid,
                        mapUid: val.mapUid
                    },
                    language: this.lang
                }
                    this.isBtnajax = true
                ajax.post(api.POPUP, params).then(res => {
                    this.isBtnajax = false
                    this.QueryUpdatas = res;
                    this.QueryUpdatas.uid = dataValues.uid
                    this.QueryUpdatas.specialModule = specialModule
                    this.QueryUpdatas.behrUid = val.btnUid;
                    this.QueryUpdatas.fieldMapUid = val.mapUid;
                    this.QueryUpdatas.toGmcuid = val.pattern.gmcUid;
                    this.QueryUpdatas.lookupCode = val.code;
                    this.QueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                    this.QueryUpdatas.type = 'To'
                    if(val.pattern.action == "scanin"){
                        this.QueryUpdatas.zdSave = true
                    }
                    this.apiType = "edit";
                    this.eddvisible = true;
                });
                return
            }

            if (val.type == "POPUP" && val.viewType == "LIST") {
                params.importType = "DB";
                params.gmcUid = val.pattern.gmcUid;
                params.partTableUid = this.tableGmcuid;
            } else if (val.type == "File" && val.viewType == "EXCEL") {
                params.importType = "excel";
                params.gmcUid = val.pattern.gmcUid;
            } else {
                this.$customMessage.warning(this.$t('publicLang.SystemAdministrator'), 3);
                return;
            }
            this.importparams = params;
            this.importVisible = true;
            }
            //        pdf
            if (val.code == "BTN_PRINT") {
                if (val.viewType == "LIST") {
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    }
                } else {
                    if (this.pb_selectList.length != 1) {
                        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                        return;
                    }
                }
                let tt = [];
                console.log(this.pb_selectList);
                for (let ii in this.pb_selectList) {
                    tt.push(this.pb_selectList[ii].uid);
                }
                // 打印预览
                this.printPreview(tt,val);
            }
            //        export
            if (val.code == "BTN_EXPORT") {
                if (val.patternType == "EXT") {
                    let ajaxurl = ajax.ajaxUrl();
                    this.isBtnajax = true
                    let that = this
                    axios.get(ajaxurl + val.externalApi, {
                        params: {
                            btnUid: val.btnUid,
                            language: this.lang
                        },
                        headers: {
                        Authorization: cookie.getBearerToken()
                        },
                        responseType: "blob" //二进制流
                    })
                    .then(function(data) {
                        that.isBtnajax = false
                        if (!data) {
                            return;
                        }
                        var blob = new Blob([data.data], {
                        type:
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                        });
                        var url = window.URL.createObjectURL(blob);
                        var aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        aLink.setAttribute("download", "excel.xlsx");
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink); //下载完成移除元素
                        window.URL.revokeObjectURL(url); //释放掉blob对象
                    })
                    .catch(function(error) {
                        alert(error);
                    });
                }
                if(val.viewType == "EXCEL"){
                    let params = {
                        gmcUid: this.tableGmcuid,
                        language: this.lang,
                        export: 'excel',
                    }
                    let arr = this.initRenderFnSearchParamsArr.andvanSearchArr // adv search
                    let tileArr = this.initRenderFnSearchParamsArr.titleSearchArr // title Search
                    if(tileArr.length > 0 ){
                        params.columnSearch = tileArr
                    }else{
                        if(!(arr instanceof Array)){
                            if(JSON.stringify(arr) !="{}"){
                                params.userSqlDto = arr
                            }else if(this.parTableTemplateName != undefined && this.parTableTemplateName != null){                                
                                params.userSqlDto = {};
                                params.userSqlDto.gmcUid = this.tableGmcuid
                                params.userSqlDto.template = this.parTableTemplateName                  
                            }
                        }
                    }
                    let ajaxurl = ajax.ajaxUrl();
                    this.isBtnajax = true
                    let that = this
                    ajax.exportExcel(ajaxurl+api.SKUS,params).then(data=>{
                        that.isBtnajax = false
                        if (!data) {
                            return;
                        }
                        var blob = new Blob([data.data], {
                            type:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                        });
                        var url = window.URL.createObjectURL(blob);
                        var aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        aLink.setAttribute("download", "excel.xlsx");
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink); //下载完成移除元素
                        window.URL.revokeObjectURL(url); //释放掉blob对象
                    })
                }
            }
            //      save
            if (val.code == "BTN_SAVE") {
                if (val.type == "BUTTON" && val.patternType == "EXT") {
                    let paramsData = [];
                    if (val.pattern.params.length > 0) {
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        }
                        let SaveData = this.pb_selectList;
                        let patterParams = val.pattern.params;
                        for (let index in SaveData) {
                            if (SaveData[index].uid != "") {
                                let paramsObj = {};
                                paramsObj.key = "uid";
                                paramsObj.value = SaveData[index].uid;
                                paramsData.push(paramsObj);
                            }
                        }
                    }
                    let params = {
                        behrUid: val.btnUid,
                        userUid: this.$route.query.userUid,
                        functionUid: this.$route.query.funcUid,
                        gmcUid: val.pattern.gmcUid,
                        params: paramsData,
                        language: this.lang
                    };
                    let that = this
                    if(val.pattern.custPage === 'VehicleInactive' || val.pattern.custPage === 'VehicleActive'){
                        this.$customConfirm({
                            title: this.$t('processActionMsg'),
                            okText: this.$t('publicLang.Confirm'),
                            okType: 'confirm',
                            cancelText: this.$t('publicLang.Cancel'),
                            onOk() {
                                ajax.post(val.externalApi, params).then(res => {
                                    if (res.code == 200) {
                                        that.initRenderFn();
                                        that.$message.success(res.msg, 3);
                                    } else {
                                        that.$customMessage.warning(res.msg, 3);
                                    }
                                });
                            },
                        })
                        return
                    }
                    ajax.post(val.externalApi, params).then(res => {
                        if (res.code == 200) {
                            if(val.externalApi=="/cfs/shipment/printLabelUrl" ||  val.externalApi=="/cfs/generateLabel"){
                                let urlStr =  res.data;
                                this.shipmentUrl = urlStr.split(",")
                                // this.shipmentUrl=res.msg;
                                if(this.shipmentUrl==null || this.shipmentUrl.length==0){
                                    this.$message.success("No Data", 3);
                                }
                                for (let i = 0; i <this.shipmentUrl.length ; i++) {
                                    window.open(this.shipmentUrl[i]);
                                }
                            }else{
                                this.initRenderFn();
                                this.$message.success(res.msg, 3);
                            }
                        } else {
                            this.$customMessage.warning(res.msg, 3);
                        }
                    });
                }
                if (val.type == "POPUP" && val.viewType == "SINGLE") {
                    if (this.pb_selectList.length != 1) {
                        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                        return;
                    }
                    this.QueryUpdatas = {};
                    let paramsData = [];
                    let dataValues = this.pb_selectList[0];
                    let params = {
                        gmcUid: val.pattern.gmcUid,
                        dataUid: dataValues.uid,
                        language: this.lang,
                        isChecked: false
                    };
                    this.$nextTick(() => {
                        this.$refs.popupSingleRef.openPopup();
                    });
                    ajax.post(api.POPUP, params).then(res => {
                        this.QueryUpdatas = res;
                        this.QueryUpdatas.behrUid = val.btnUid;
                    });
                }
                if (val.type == "POPUP" && val.viewType == "LIST") {
                    let params = {
                        btnUid: val.btnUid,
                        userUid: this.$route.query.userUid,
                        language: this.lang,
                        fieldMapUid: val.mapUid,
                        importTitle: val.name
                    };
                    params.importType = "DB";
                    params.gmcUid = val.pattern.gmcUid;
                    this.importparams = params;
                    this.importVisible = true;
                }
                //            弹指定弹窗
                if(val.type == "POPUP" && val.pattern.custPage == "lookUp"){
                    if (this.pb_selectList.length != 1) {
                        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                        return;
                    }
                    let feildArr = []
                    let dataValues = this.pb_selectList[0]
                    let feildPatternParams = val.pattern.params
                    for (let ii in dataValues) {
                        for (let tt in feildPatternParams) {
                            if (ii == feildPatternParams[tt]) {
                                feildArr.push({key: ii, value: dataValues[ii].value})
                            }
                        }
                    }
                    let params = {
                        gmcUid: this.data.gmcUid,
                        language: this.lang,
                        noEvent: true,
                        lookup: {
                            gmcUid: val.pattern.gmcUid,
                        }
                    }
                    params.feildArr = feildArr
                    this.lookupParams = params;
                    this.$refs.lookupRefs.showModal();
                }
                if (val.pattern.custPage == "manual" && val.type == "BUTTON") {
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    }
                    let manualData = this.pb_selectList;
                    let paramsData = [];
                    for (let index in manualData) {
                        if (manualData[index].uid != "") {
                            let paramsObj = {};
                            paramsObj.key = "uid";
                            paramsObj.value = manualData[index].uid;
                            paramsData.push(paramsObj);
                        }
                    }
                    let params = {
                        gmcUid: val.pattern.gmcUid,
                        language: this.lang,
                        params: paramsData,
                        userUid: this.$route.query.userUid
                    };
                    this.manualParams = params;
                    this.$refs.manual.openModal();
                }
                if (val.pattern.custPage == "Cron_task" && val.type == "BUTTON"){
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    }
                    let deleteData = this.pb_selectList;
                    let paramsData = [];
                    for (let index in deleteData) {
                        paramsData.push(deleteData[index].uid)
                    }
                    ajax.post(api.ADDJOBSCHEDULE,{uids: paramsData,funcType: "SCHD_TASK"}).then(res=>{
                        if (res.code === 200) {
                            this.$message.success(res.msg)
                        }else{
                            this.$customMessage.error(res.msg)
                        }
                    })
                }
                if (val.pattern.custPage == "Cron" && val.type == "BUTTON"){
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    }
                    let deleteData = this.pb_selectList;
                    let paramsData = [];
                    for (let index in deleteData) {
                        paramsData.push(deleteData[index].uid)
                    }
                    ajax.post(api.ADDJOBSCHEDULE,{uids: paramsData,funcType: "WAVE"}).then(res=>{
                        if (res.code === 200) {
                            this.$message.success(res.msg)
                        }else{
                            this.$customMessage.error(res.msg)
                        }
                    })
                }
                if (val.pattern.custPage == "Create Wave" && val.type == "BUTTON") {
                    this.$refs.createWaveRef.open();
                }
                if (val.pattern.custPage == "part-de-allocation" && val.type == "BUTTON") {
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    } else {
                        let params = [];
                        for (let ii in this.pb_selectList) {
                            params.push(this.pb_selectList[ii].uid);
                        }
                        ajax.post(api.SOHEADERALLOCAION, { uids: params }).then(res => {
                            if (res.code == 200) {
                            this.$message.success(res.msg);
                            }
                        });
                    }
                }
                if (val.pattern.custPage == "Generate Location" && val.type == "BUTTON") {
                    this.$refs.generateLocationRef.open();
                }
                if (val.pattern.custPage == "Batch_Update" && val.type == "BUTTON") {
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    }
                    let Batchdata = this.pb_selectList;
                    let batchDataArr = [];
                    for (let index in Batchdata) {
                        if (Batchdata[index].uid != "") {
                            let paramsObj = {};
                            paramsObj.key = "uid";
                            paramsObj.value = Batchdata[index].uid;
                            batchDataArr.push(paramsObj);
                            batchDataArr.push({
                            key: "version",
                            value: Batchdata[index].version
                            });
                        }
                    }
                    this.bathUpdatparams = {
                        gmcUid: val.pattern.gmcUid,
                        language: this.lang,
                        batchDataArr: batchDataArr,
                        btnUid: val.btnUid
                    };
                    this.$refs.bathUpdateRef.open();
                }
                if (val.pattern.custPage == "scanpack" && val.type == "BUTTON") {
                    if (this.pb_selectList.length != 1) {
                        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                        return;
                    } else {
                        let dataValues = this.pb_selectList[0];
                        this.$refs.scanpackRefs.show(dataValues.uid,this.data.tableList.info);
                    }
                }
                if(val.pattern.custPage == "scanin" && val.type == "BUTTON"){
                    if (this.pb_selectList.length != 1) {
                        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                        return;
                    } else {
                        let dataValues = this.pb_selectList[0]
                        this.$refs.scanInRefs.showIn(dataValues.uid,this.data.tableList.info)
                    }
                }
                if(val.pattern.custPage == "loading" && val.type == "BUTTON"){
                    this.$refs.loadingRefs.loadingShow()
                }
                if(val.pattern.custPage == "adjust" && val.type == "BUTTON"){
                    let params = {}
                    if(this.pb_selectList.length > 0){
                        let arr = []
                        for(let i in this.pb_selectList){
                            arr.push(this.pb_selectList[i].uid)
                        }
                        params.uids = arr
                        params.mark = val.pattern.custPage
                        this.$refs.adjust.show(this.tableGmcuid,params)
                    }else{
                        this.$refs.adjust.show(this.tableGmcuid)
                    }
                }
                if(val.pattern.custPage == "Move" && val.type == "BUTTON"){
                    let params = {}
                    if(this.pb_selectList.length > 0){
                        let arr = []
                        for(let i in this.pb_selectList){
                            arr.push(this.pb_selectList[i].uid)
                        }
                        params.uids = arr
                        params.mark = val.pattern.custPage
                        this.$refs.adjustMove.show('Move',params)
                    }else{
                        this.$refs.adjustMove.show('Move')
                    }
                }
                if(val.pattern.custPage == "Split" && val.type == "BUTTON"){
                    this.$refs.splitRef.showSplit()
                }
                if(val.pattern.custPage == "deliverydate" && val.type == "BUTTON"){
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    }
                    let deleteData = this.pb_selectList;
                    let paramsData = [];
                    for (let index in deleteData){
                        let paramsObj = {};
                        paramsObj.key = "uid";
                        paramsObj.value = deleteData[index].uid;
                        paramsData.push(paramsObj);
                    }
                    paramsData.push({key: 'moduleName', value: this.data.tableList.info})
                    let tt = {
                        behrUid: '',
                        fieldMapUid: '',
                        functionUid: '',
                        gmcUid: '',
                        language: this.lang,
                        params: paramsData,
                        type: '',
                        userUid: '',
                    }
                    this.$refs.deliveryDate.show(tt)
                }
                if(val.pattern.custPage == 'transfer' && val.type == 'BUTTON'){
                    let uidList = []
                    for(let i in this.pb_selectList){
                        uidList.push(this.pb_selectList[i].uid)
                    }
                    this.$refs.transfer.transferShow(uidList)
                }
                if(val.pattern.custPage == 'BatchUpdateShipment' && val.type == 'BUTTON'){
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    }
                    let uidList = []
                    for(let i in this.pb_selectList){
                        uidList.push(this.pb_selectList[i].uid)
                    }
                    let params = {
                        uidList: uidList.join(","),
                        subModuleCode: this.data.tableList.info,
                        gmcUid: this.tableGmcuid,
                        btnGmcUid: val.pattern.gmcUid,
                        btnUid:val.btnUid
                    }
                    this.$refs.batchShipment.show(params)
                }
                if(val.pattern.custPage == 'buttonConfig' && val.type == 'BUTTON'){
                    if (this.pb_selectList.length == 1) {
                        this.$refs.buttonConfigRef.show(this.pb_selectList[0].uid)
                    }else{
                        this.$refs.buttonConfigRef.show()
                    }
                }
                if (val.type == "BUTTON" && val.pattern.custPage == "createPallet"){
                    this.$refs.addConsignmentRefs.show('ULD#')
                }
                if (val.type == "BUTTON" && val.pattern.custPage == "createShipment"){
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                        return;
                    }
                    let uids = [];
                    for (let index in this.pb_selectList){
                        uids.push(this.pb_selectList[index].uid)
                    }
                    this.$refs.addConsignmentRefs.show('MAWB','pallet',uids)
                }
                if (val.type == "BUTTON" && val.pattern.custPage == "BatchUpdateMAWB"){
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                        return;
                    }
                    let uids = [];
                    for (let index in this.pb_selectList){
                        uids.push(this.pb_selectList[index].uid)
                    }
                    this.$refs.addConsignmentRefs.show('MAWB','BatchUpdateMAWB',uids)
                }
                if (val.type == "BUTTON" && val.pattern.custPage == "palletHeader"){
                    let params = {
                        btnUid: val.btnUid,
                        userUid: this.$route.query.userUid,
                        language: this.lang,
                        fieldMapUid: val.mapUid,
                        importTitle: val.name,
                        gmcUid: val.pattern.gmcUid,
                        partTableUid: this.tableGmcuid,
                        palletType: 'palletHeader'
                    }
                    this.importparams = params;
                    this.addPalletVisible = true
                }
                if(val.pattern.custPage == "shedule_batch" && val.type == 'BUTTON'){
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    }
                    let paramsData = [];
                    for (let index in this.pb_selectList) {
                        paramsData.push(this.pb_selectList[index].uid)
                    }
                    this.$refs.shduleBatchRef.show({arr:paramsData})
                }
            }
        },
        GETcancelImport(val) {
            this.addPalletVisible = false
            this.importVisible = false;
            this.getTemplateName()
            if (val == "init") {
                this.init("empty_temp")
            }
        },
        getBtnConfigemit(){
            this.init();
        },
        GETcancelModalVisible(val) {
            this.eddvisible = false;
            this.getTemplateName()
            if (val != "close") {
            this.init("empty_temp")
            }
        },
        getdeliverdate(){
            this.init();
        },
        getMoveSave(){
            this.initRenderFn()
        },
        printPreview(tt,val){
            let ajaxurl = ajax.ajaxUrl();
            let that = this;
            this.isBtnajax = true

            axios.post(ajaxurl + api.PRINTPREVIEW, {
                    gmcUid: this.tableGmcuid,
                    uid: tt.toString(),
                    btnName: val.name,
                    btnUid: val.btnUid
                }, {
                headers: {
                    Authorization: cookie.getBearerToken()
                },
                responseType: "blob" //二进制流
            }).then(function(res) {
                let resHeader = res.headers;
                let contentType = resHeader["content-type"];
                let excelContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
                if(excelContentType.indexOf(contentType) !=-1) {
                    //excel
                    that.isBtnajax = false
                    var data  = res;
                    if (!data) {
                        return;
                    }
                    var blob = new Blob([data.data], {
                        type:
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                    });
                    var url = window.URL.createObjectURL(blob);
                    var aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download", "excel.xlsx");
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                } else {
                    //pdf
                    that.pubPdfMsgfn(res);
                }
            });
        },
    }
};
</script>
<style lang="less">
    /*@import "https://cdn.bootcss.com/bootstrap/3.3.5/css/bootstrap.css";*/
    @import "../../assets/css/bootstrap.css";
    #queryBuilder {
        overflow: hidden;
    }
    .queryBtnSty {
        margin: 4px 0;
    }
    #skuPage {
        background: #fff;
        .ant-collapse-content > .ant-collapse-content-box {
            padding: 0;
        }
    }
    .ant-drawer-body {
        padding: 2px;
    }
</style>
